var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useTransition, animated } from '@react-spring/web';
import { OnboardingSelectionStep } from './onboarding-selection-step';
import { OnboardingLayout } from './onboarding-layout';
import { OnboardingHeader } from './onboarding-header';
import { useLang } from '../hooks/use-lang';
import { OnboardingButton } from './onboarding-button';
import { ContentNode } from '../entities/content-node';
import { GridLoader } from './grid-loader';
import { useLink } from '../hooks/use-link';
import { useSite } from '../hooks/use-site';
import { UpdatePasswordFormLayout } from './update-password-form-layout';
import { OnboardingView } from '../entities/onboarding-view';
import { useOnboarding } from '../context/onboarding-context';
var cls = classNames('onboarding-steps');
export var OnboardingStepsDefaultProps = {
  verify: ''
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TransitionContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    width: 100%;\n    height: 100%; \n    max-width: 700px;\n    margin: 0 ", ";\n  "], ["\n    position: relative;\n    width: 100%;\n    height: 100%; \n    max-width: 700px;\n    margin: 0 ", ";\n  "])), theme.UNIT(6))
});
var OnboardingStepStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: ", ";\n  "], ["\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: ", ";\n  "])), theme.UNIT(9))
});
var ContinueStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ChangePasswordMessageStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    text-align: center;\n  "], ["\n    text-align: center;\n  "])))
});
var LoaderStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    min-height: 100px;\n  "], ["\n    min-height: 100px;\n  "])))
});
var LoginStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'OnboardingSteps',
  Container: styled(OnboardingLayout)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled(OnboardingHeader)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  OnboardingStep: styled(OnboardingSelectionStep)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), OnboardingStepStyles),
  TransitionContainer: styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), TransitionContainerStyles),
  Body: styled(animated.div)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  ContinueButton: styled(OnboardingButton)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ContinueStyles),
  Loader: styled(GridLoader)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles),
  ChangePasswordMessage: styled(ContentNode)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ChangePasswordMessageStyles),
  Login: styled(UpdatePasswordFormLayout)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), LoginStyles)
};
export var OnboardingSteps = function (props) {
  var _a;
  var componentProps = useComponentProps(My.NAME, OnboardingStepsDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    verify = componentProps.verify;
  var _b = useOnboarding(),
    currentStep = _b.currentStep,
    movingToStep = _b.movingToStep,
    setCurrentStep = _b.setCurrentStep,
    onboardingSteps = _b.onboardingSteps,
    loading = _b.loading,
    goToPreviousStep = _b.goToPreviousStep,
    onPasswordSubmit = _b.onPasswordSubmit,
    onboardingState = _b.onboardingState;
  var site = useSite();
  var destination = ((_a = site === null || site === void 0 ? void 0 : site.explorerPage) === null || _a === void 0 ? void 0 : _a.path) || '/app/profile';
  var navigate = useLink().navigate;
  var t = useLang();
  var transitions = useTransition(currentStep, {
    key: movingToStep,
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    },
    config: {
      duration: 300
    },
    exitBeforeEnter: true,
    // reset current step to movingToStep when animation is done
    onDestroyed: function () {
      return setCurrentStep(movingToStep);
    }
  });
  // set styles here to not cluster animated.div
  var animatedDivStyles = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  };
  var currentConfig = onboardingSteps[currentStep];
  return React.createElement(My.Container, {
    totalSteps: onboardingSteps.length,
    currentStep: currentStep,
    className: cls.name(className)
  }, React.createElement(My.TransitionContainer, null, transitions(function (style, stepIndex) {
    var isFinalStep = stepIndex === onboardingSteps.length - 1;
    return React.createElement(My.Body, {
      style: __assign(__assign({}, style), animatedDivStyles)
    }, isFinalStep ? onboardingState.password ? loading ? React.createElement(My.Loader, null) : React.createElement(React.Fragment, null, React.createElement(My.ChangePasswordMessage, {
      entity: {
        text: 'Thanks for completing the setup process. Click the button below to login with your new password and explore the community.'
      }
    }), React.createElement(My.ContinueButton, {
      onClick: function () {
        return navigate(destination);
      }
    }, t('Continue'))) : React.createElement(My.Login, {
      goToPreviousStep: goToPreviousStep,
      onSubmit: onPasswordSubmit
    }) : React.createElement(OnboardingView, {
      view: currentConfig.view
    }));
  })));
};
OnboardingSteps.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;